import CheckContacts from '@/components/form/check-contacts'
import Spinner from '@/components/ui/spinner'
import { useFetchClientByCnpjCpf, useLinkSigningContact } from '@/features/client/services'

interface Props {
  id_client: string
  onComplete: () => void
}

export function SignatureContactVerificationStep({ id_client, onComplete }: Props) {
  const { data: clientData, isLoading } = useFetchClientByCnpjCpf(id_client)
  const { mutateAsync: linkSigningContact } = useLinkSigningContact(id_client)

  if (isLoading || !clientData) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <div className="mb-6 rounded-lg border bg-card p-4">
        <h2 className="text-lg font-semibold">Validação de contato antes da assinatura</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Confirme o WhatsApp e o e-mail do responsável. Se forem diferentes dos contatos já cadastrados, eles serão
          vinculados ao cliente como contato adicional.
        </p>
      </div>

      <CheckContacts
        expectedCpf={clientData.cpfProprietario ?? ''}
        onSuccess={async data => {
          await linkSigningContact({
            nome: data.name,
            document: data.cpf,
            contato: data.whatsapp,
            email: data.email,
            isContatoVerified: true,
            isEmailVerified: true
          })

          onComplete()
        }}
      />
    </div>
  )
}
